import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { RoutingConfig } from '@app/routing/routing.config';

/** Navigation state key for slug when navigating from "My performers" to edit. */
export const PERFORMER_EDIT_STATE_SLUG = 'performerEditSlug';

/** Navigation state key for isPublished when navigating from "My performers" to edit. */
export const PERFORMER_EDIT_STATE_IS_PUBLISHED = 'performerEditIsPublished';

/**
 * Allows activation of the performer edit route only when navigated from "My performers"
 * with slug passed in state. Otherwise redirects to the performers list.
 */
@Injectable()
export class GuardPerformerEditService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state;
    const hasSlugInState = state != null && PERFORMER_EDIT_STATE_SLUG in state;
    if (!hasSlugInState) {
      this.router.navigate([
        '/',
        RoutingConfig.Account,
        RoutingConfig.AccountPerformers
      ]).catch(() => {});
      return false;
    }
    return true;
  }
}
